import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemSetting, SystemSettingOverTime, UpdateSettingRequest, SystemSettingSearchSpec } from "../models/system-setting.model";

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {

	private BaseURL: string = "/api/system-settings";

	constructor(private _client: HttpClient) { }

	getAll(): Observable<SystemSetting[]> {
		return this._client.get<SystemSetting[]>(this.BaseURL);
	}


	save(setting: UpdateSettingRequest): Observable<SystemSetting[]> {
		return this._client.post<SystemSetting[]>(`${this.BaseURL}/save`, setting);
	}

	search(spec: SystemSettingSearchSpec): Observable<SystemSetting[]> {
		return this._client.post<SystemSetting[]>(`${this.BaseURL}/search`, spec);
	}

	searchOverTime(spec: SystemSettingSearchSpec): Observable<SystemSettingOverTime[]> {
		return this._client.post<SystemSettingOverTime[]>(`${this.BaseURL}/time-search`, spec);
	}
}
